import { render, staticRenderFns } from "./Zip.vue?vue&type=template&id=127b566a"
import script from "./Zip.vue?vue&type=script&lang=js"
export * from "./Zip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports